import React from 'react';

export function ReportFooter({ branding }) {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="report-footer">
            <div className="footer-content">
                <p className="footer-powered">
                    Generado con <strong>{branding?.powered_by || 'Dashbo'}</strong>
                </p>
                <p className="footer-copyright">
                    {currentYear} Dashbo. Todos los derechos reservados.
                </p>
            </div>
        </footer>
    );
}
